import { ChatComponent } from '../chats/chat/chat.component';
import { FeedbackEditComponent } from './feedback-edit/feedback-edit.component';
import { FeedbackDetailComponent } from './feedback-detail/feedback-detail.component';
import { FeedbacksComponent } from './feedbacks.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../shared/auth/auth.guard';

@NgModule({
  imports: [
    RouterModule.forChild([
      {

        path: 'feedbacks',
        canActivate: [AuthGuard],
        component: FeedbacksComponent,
        children: [
          {
            path: ':id',
            component: FeedbackDetailComponent,
          }
        ],
      },
      {
        path: 'feedbacks/:id/edit',
        canActivate: [AuthGuard],
        component: FeedbackEditComponent
      }
    ])
  ],
  exports: [RouterModule]
})
export class FeedbacksRoutingModule { }



// WEBPACK FOOTER //
// /ng-app/src/app/feedbacks/feedbacks.routing.module.ts